/* eslint-disable max-lines */

// Mocks
export { default as getTestProvider } from './test/util/getTestProvider';
export * as MockHook from './util/useMockHook';
export * as PoliciesMocks from './policies/mocks';

// API
export { default as useJ1AuthFetch } from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useJ1AuthFetch';
export type { useJ1AuthFetchReturn } from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useJ1AuthFetch';
export * from '@jupiterone/jupiter-web-toolkit/types';
export { useCreateEntity, useUpdateEntity } from './api/entity';
export { AccountCompanyRoles, useCreateJ1AccountEntity } from './api/j1Account';
export type {
  AccountFormFieldValues,
  OrganizationFormFieldValues,
} from './api/j1Account';
export { SessionContext, useSession } from './api/session';
export { default as ApolloClientWithSnap } from './apollo/ClientWithSnap';
export { default as J1ApolloClient } from './apollo/J1ApolloClient';
export * from './apollo/createApolloClientQueryHook';
export * from './apollo/createUseMutationHook';
export * from './apollo/createUseQueryHook';
export * from './graphql';
export * from './entitlements';
export * from './policies/graphql/usePolicyItemTemplate';
export { default as useLazyGetProcedures } from './policies/graphql/useLazyGetProcedures';

export { default as usePolicyDraftApi } from './policies/graphql/useDraftApi';
// shallow refactored code here
export * from './areaChart';
export * from './barChart';
export * from './chart';

// CLIENTS
export { default as useAccountClient } from './clients/useAccountClient';
export { default as useGroupClient } from './clients/useGroupClient';
export { default as useInviteClient } from './clients/useInviteClient';
export { default as useUrlShortener } from './clients/useUrlShortener';
export { useAccounts } from './api/fetch/useAccounts';
export * from './api/fetch/useAccounts/accounts.mock';
export { useUser } from './api/fetch/useUser';
export { useABAC, ABACProvider } from './api/fetch/useABAC';

// text fields
export { default as J1Searchbar } from './components/J1Searchbar';
export { default as AppProviders } from './components/AppProviders';
export * from './components/AuditEvents';
export { default as TextFieldWithHintIcon } from './components/TextFieldWithHintIcon';
// authentication
export { default as AuthRoutes } from './components/authentication/AuthRoutes';
export * from './components/AutocompleteMultiSelect';
// badge
export { default as Badge } from './components/badge/Badge';
// beta ribbon
export { default as BetaRibbon } from './components/BetaRibbon/BetaRibbon';
export { default as ButtonWithLoadingState } from './components/buttons/ButtonWithLoadingState';
export { default as CloseButton } from './components/buttons/CloseButton';
export { default as EditableButton } from './components/buttons/EditableButton';
export { default as DrawerButton } from './components/buttons/DrawerButton';
// buttons
export { default as EditableButtonList } from './components/buttons/EditableButtonList';
export { default as TabButton } from './components/buttons/TabButton';
// cards
export { default as FlatOutlinedCard } from './components/cards/FlatOutlinedCard';
export { default as SummaryCard } from './components/cards/SummaryCard';
// chips
export { default as StatusChip } from './components/chips/StatusChip';
// dialogs
export * from './components/dialogs/managePermissionDialog';
//Icons
export { default as ClassIcon } from './components/ClassIcon';
// drag-n-drop
export {
  default as DraggableContainer,
  DRAGGABLE_HEADER_CLASSNAME,
} from './components/drag-n-drop/DraggableContainer';
export * from './components/drag-n-drop/ResponsiveGridLayout';
export * from './components/drag-n-drop/SortableDnd';
// drawers
export { default as CollapseableDrawer } from './components/drawers/CollapseableDrawer';
export * from './components/drawers/EntityDrawer';
export { default as CreateEntityModal } from './components/drawers/EntityDrawer/CreateEntity/CreateEntityModal';
export { UpdateEntity } from './components/drawers/EntityDrawer/queries';
export { default as convertVertexToEntity } from './components/drawers/EntityDrawer/utils/convertVertexToEntity';
// Editors
export { default as JSONEditor } from './components/Editors/JSONEditor';
export { default as AceMarkdown } from './components/AceMarkdown';
export * as j1qlAutocomplete from './autocomplete';
// error
export { default as CodeError } from './components/error/CodeError';
export { default as ErrorBoundary } from './components/error/ErrorBoundary';
// forms
export { default as ProceduresForm } from './policies/ProceduresForm';
// formatters
export { default as DateDisplay } from './components/formatters/DateDisplay';
export { formatDate } from './components/util/formatter';
// Inputs
export * from './components/inputs';
export * from './components/JiraCollector';
// modals
export { default as ConfirmationPrompt } from './components/Modals/ConfirmationPrompt';
export {
  default as useConfirmationPrompt,
  ConfirmationPromptProvider,
} from './components/Modals/useConfirmationPrompt';
export { default as RawDataModal } from './components/Modals/RawData';
export { default as MultiSelectMenu } from './components/MultiSelect/MultiSelectMenu';
export { default as MultiSelectMenuItem } from './components/MultiSelect/MultiSelectMenuItem';
export { default as EllipsisMenu } from './components/menus/EllipsisMenu';
export { default as ReportIssueDialog } from './components/ReportIssueForm/ReportIssueDialog';
// notifications
export {
  SnackbarNotificationContext,
  SnackbarNotificationProvider,
  useSnackbarNotification,
} from './components/notifications/SnackbarNotificationContext';
export { default as OrganizationFormFields } from './components/OrganizationFormFields/OrganizationFormFields';
export * from './components/OrganizationFormFields/util/validate';
// 404
export { default as PageNotFound } from './components/PageNotFound';
export { default as PermissionChecker } from './components/permissionChecker/PermissionChecker';
export * from './components/PersonBubble';
// progress
export { default as LoadingSpinner } from './components/progress/LoadingSpinner';
export { default as LogoProgress } from './components/progress/LogoProgress';
export { default as QueryResult } from './components/QueryResult/QueryResult';
export { default as SortablePaginationQueryResult } from './components/QueryResult/SortablePaginationQueryResult/SortablePaginationQueryResult';
export { default as VariantQuestionModal } from './components/QuestionModal/VariantQuestionModal/VariantQuestionModal';
export type { QuestionModalVariant } from './components/QuestionModal/VariantQuestionModal/useVariantQuestionModalLogic';
export { default as QuestionResult } from './components/QuestionResult/QuestionResult';
// questionResult
export { default as QuestionTrendChart } from './components/QuestionResult/QuestionTrendChart';
export { default as TabQueryResultList } from './components/QuestionResult/TabQueryResultList/TabQueryResultList';
// scroll
export { default as InfiniteScroll } from './components/scroll/InfiniteScroll';
export * from './components/scroll/types';
export { default as useInfiniteScroll } from './components/scroll/useInfiniteScroll';
// SearchBars
export { default as QuickSearch } from './components/search/QuickSearch';
// COMPONENTS
export { default as Snackbar } from './components/Snackbar';
export { default as Popover } from './components/Popover';
// steppers
export { default as VerticalRadioCheckboxStepper } from './components/steppers/VerticalRadioCheckboxStepper';
export { default as ThemeWrap } from './components/ThemeWrap';
// Exporting this here, would also require to import AceEditor globally...
// export { default as AceModeJ1QL } from './util/aceModeJ1QL';
// typography
export { default as StyledHTMLAnchor } from './components/typography/StyledHTMLAnchor';
export { default as UserAvatar } from './components/UserAvatar';
export { default as ConditionalWrap } from './components/util/ConditionalWrap';
// utils
export { default as CopyToClipboard } from './components/util/CopyToClipboard';
export { default as DragDropFileUpload } from './components/util/DragDropFileUpload';
export * from './components/util/entityDrawerUtils';
export {
  FeatureFlagsContext,
  FeatureFlagsProvider,
  useFeatureFlags,
} from './components/util/FeatureFlagsContext';
export { formatJ1QueryValue } from './components/util/formatJ1QueryValue';
export {
  default as formatProperty,
  formatPropertyBasedOnNameValue,
} from './components/util/formatter';
export { default as hasAccount } from './components/util/hasAccount';
export { default as stripTypeName } from './components/util/stripTypeName';
export { numberWithCommas } from './util/numberWithCommas';
export * from './constants';
export * from './analytics';
// Features
export * from './errorHandling';
export * from './filterChipList';
// HOOKS
export * from './hooks';
// CONTEXT
export * as LogoContext from './context/LogoContext';
// GRAPHQL
export { default as useOptimisticQuery } from './hooks/graphql/useOptimisticQuery';
export type {
  OptimisticQueryResults,
  OptimisticQueryUpdate,
} from './hooks/graphql/useOptimisticQuery';
export * from './icons';
export * from './icons/JupiterOneIcon';
export * from './icons/JupiterOneGradientIcon';
export * from './icons/JupiterOneGradientIconBlackText';
export * from './icons/JupiterOneGradientIconWhiteText';
export * from './icons/JupiterOneWhiteIconWhiteText';
export { default as IconClipboard } from './icons/Clipboard';
export { default as IndicatorChip } from './indicatorChip/IndicatorChip';
export type { IndicatorChipProps } from './indicatorChip/IndicatorChip';
export * from './integrations';
export * from './j1Dialog';
export * from './j1QueryChart';
export * from './lineChart';
export * from './matrixChart';
export * from './neckBar';
export * from './numberChart';
export * from './pdf';
export * from './percentageBarChart';
export * from './pieChart';
export * from './questions';
export * as policyBuilderConfigReducers from './reducers/policyBuilderConfigReducers';
export * from './session';
export * from './tableChart';
export { default as StatusChart } from './components/StatusChart';
export { default as ResultIcon } from './components/ResultIcon';
export { default as reportError } from './util/reportError';
// Testing Utils
export * from './test';
// theme
export * from './theme';
// STYLES
export { default as darkThemeStyles } from './theme/DarkTheme.styles';
export { default as aceEditorStyles } from './styles/AceEditor.styles';
// URLS
export { default as urlLinks } from './urlLinks';
// Types
export {
  StatusWidgetDataFromQueriesProps,
  getStatusWidgetDataFromQueries,
} from './j1QueryChart/statusChartUtils';
export * from './types';
export * as PolicyTypes from './policies/graphql/types__generated';
export type { RawDataEntity } from './components/Modals/RawData/types';
// CONSTANTS
export { default as urls } from './urls';
// Branding logos
export { default as CurrentOEMBrandingLogo } from './components/CurrentOEMBrandingLogo';
export { default as CustomLogo } from './components/CustomLogo';
export { default as allowKeysDeep } from './util/allowKeysDeep';
export { propertyRevisionData } from './util/atProperty';
export type { PropertyRevisionData } from './util/atProperty';
export { default as base64DecodeUnicode } from './util/base64DecodeUnicode';
export { default as base64EncodeUnicode } from './util/base64EncodeUnicode';
export { default as blobToFile } from './util/blobToFile';
export { default as colorByAlertLevel } from './util/colorByAlertLevel';
export { default as compact } from './util/compact';
export { default as compose } from './util/compose';
// UTILS
export { default as convertCanvasToImage } from './util/convertCanvasToImage';
export { default as copyToClipboard } from './util/copyToClipboard';
export { default as createMockClient } from './util/createMockClient';
export { default as createSessionManager } from './util/createSessionManager';
export { default as dataURIToBlob } from './util/dataURIToBlob';
export { default as ExpandableText } from './components/ExpandableText';
export * from './util/apolloErrorToString';
export * as utilUrl from './util/url';
export * from './util/apollo';
// date
export * from './util/dateFns';
export { default as download } from './util/download';
export { default as extractQueryParamsFromSearch } from './util/extractQueryParamsFromSearch';
export * from './util/findingLevels';
export * from './util/formatJ1Query';
export { default as formatPolicyTemplatePath } from './util/formatPolicyTemplatePath';
export { default as useFormatQueryUrl } from './util/useFormatQueryUrl';
export { default as generateRelationshipKey } from './util/generateRelationshipKey';
export {
  getIntegrationIcon,
  getIntegrationIconForType,
  iconMappings,
  IntegrationIcon,
  integrationList,
} from './util/getIconForIntegration';
export type { IntegrationIconProps } from './util/getIconForIntegration';
export * from './util/getJsxTextContent';
export { default as icon } from './util/icon';
export { default as integrationInstanceToMutationArguments } from './util/integrationInstanceToMutationArguments';
export { default as isAQuery } from './util/isAQuery';
export { default as omitDeep } from './util/omitDeep';
export { default as onlyUnique } from './util/onlyUnique';
export { default as parseAsJson } from './util/parseAsJson';
export { default as parseQuery } from './util/parseQuery';
export {
  pathForSecurityVertex,
  pathFromPolicyId,
  pathFromProcedureId,
  pathFromReferenceId,
} from './util/pathForSecurityVertex';
export { initPendo } from './util/pendo';
export { default as polyfillFontLoading } from './util/polyfillFontLoading';
export * from './util/properties';
export * from './util/queryCausesGap';
export { default as removeDeep } from './util/removeDeep';
export { default as retryIfTimeout } from './util/retryIfTimeout';
export * from './util/validate';
export { default as buildOrderByNode } from './util/buildOrderByNode';

// Reducers
import policyBuilderGraphInitialStateImport, * as policyBuilderGraphReducersImport from './reducers/policyBuilderGraphReducers';
import NotificationManager from './util/NotificationManager';

export const policyBuilderGraphInitialState = policyBuilderGraphInitialStateImport;
export const policyBuilderGraphReducers = policyBuilderGraphReducersImport;

export function createNotificationManager(
  notificationContainerId: string = 'jupiterone-notification-container'
) {
  return new NotificationManager({ notificationContainerId });
}
export const notificationManager = createNotificationManager();

export * from './attentionTooltip';

export { AceEditor } from './util/loadReactAce';
